<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CModal
        title="Test has been closed."
        centered
        color="light"
        :show.sync="adminLockTestModal"
        :closeOnBackdrop="false"
      >
        <h5>Contact the instructor of your section and try again later.</h5>
        <br />
      </CModal>
      <CModal
        title="Post-test has been closed."
        centered
        color="light"
        :show.sync="adminLockPostTestModal"
        :closeOnBackdrop="false"
      >
        <h5>{{ detail_posttest }}</h5>
        <br />
      </CModal>
      <full-page
        :options="options"
        id="fulp"
        ref="fullpage"
        v-if="v3FetchProgress"
      >
        <div class="section">
          <div class="body-slide">
            <SwiperItem
              :items="content"
              :lang="lang"
              :subProgress="subProgress"
              @nextRoute="nextRoute"
              :allContent="allContent"
              :lessonActive="lessonActive"
            />
          </div>
        </div>
        <div class="section text-center">
          <div class="body-slide">
            <List
              :items="content"
              :lang="lang"
              @nextRoute="nextRouteList"
              :allContent="allContent"
            />
          </div>
        </div>
      </full-page>
    </template>
  </div>
</template>

<script>
import FullPage from 'vue-fullpage.js/src/FullPage.vue';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import SwiperItem from './components/SwiperItem.vue';
import List from './components/List.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  name: 'LS01',
  components: {FullPage, Swiper, SwiperSlide, SwiperItem, List, LoadingMDL},
  data() {
    return {
      options: {
        navigation: true,
        navigationPosition: 'right',
        sectionsColor: ['#E6EFFF', '#E6EFFF'],
      },
      loading: true,
      currentRoute: '',
      content: [],
      lang: '',
      allContent: [],
      lessonActive: null,
      adminLockTestModal: false,
      adminLockPostTestModal: false,
      detail_posttest: '',
      code: '',
      section: '',
      menuCHN2: [],
      subProgress: [],
      v3Progress: [],
      v3FetchProgress: null,
      v3SubProgress: [],
      v3isLearned: false,
    };
  },
  methods: {
    async onLoadData() {
      console.log('onLoadData Begin');

      this.loading = true;

      // // เคลียค่าใน vuex storage ก่อน
      // this.$store.commit('v3/clearMainCodeItem'); // เคลีย content ที่แล้วออก
      // this.$store.commit('v3/clearCourseProgress'); //เคลีย progress เก่าออก
      // this.$store.commit('v3/v3PretestOff'); // เคลียสถานะ pretest ออก
      // this.$store.commit('v3/v3SaveErrorOff'); // เคลียสถานะ saveError ออก

      this.lang = this.$store.getters['language/getLanguage'];
      this.lessonActive = this.$store.getters['necessary/getLessonActive'];
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      // this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.courseData = this.$store.state.necessary.learningCourse;
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);

      this.$store.dispatch('v3/v3LessonLock', {
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    },
    // onLoadProgress() {
    //   console.log('onLoadProgress Begin');

    //   this.currentRoute = this.$route.name + '-' + this.$route.params.id;

    //   //
    //   const payload = {
    //     codeItem: this.currentRoute,
    //     courseId: this.$store.state.necessary.learningCourse,
    //     //courseId: this.$store.getters['necessary/getLerningCourse']._id
    //   };
    //   this.$store.dispatch('v3/fetchCourseProgress', payload);

    //   // เรียก progress มาแสดงจาก backend --> ไปที่ Watch เพื่อเช็คข้อมูล
    // },
    async checkPreTestAndLoad() {
      console.log('check pre test and load');

      const isPretest = this.$store.state.v3.isPretest;
      const isLearn = this.$store.state.v3.isLearn;
      const isPostTest = this.$store.state.v3.isPostTest;
      const isSaveError = this.$store.state.v3.saveError;

      //saveError

      //save pretest
      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: null,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: null,
          type: null,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];

      if (isPretest) {
        //is pretest true
        //save ScoreAndProgress
        //check is learn if true call save again
        //if false call onLoad data

        //is learn
        //check payload codeItem
        if (!payload[0].codeItem) {
          // console.log('is Pretest dont have code item onLoad normally');

          //call on Load
          this.onLoadData();
        } else {
          console.log('is Pretest have payload codeitem and save/islearn off');
          try {
            await this.$store.dispatch('v3/saveScoreAndProgress', payload);
          } catch (e) {
            this.onLoadData();
          }

          this.$store.commit('v3/v3IsLearnOff');
        }
      } else {
        //chcekisLearn if false onLoad Data and progress
        //if true go saveprogressAndScore
        if (!isLearn) {
          console.log('isPretest false islearn false onLoad Normally');

          //isLearn is false
          //call on load normally
          this.onLoadData();
        } else {
          console.log('isPretest false islearn true saveProgress/islearn off');

          try {
            await this.$store.dispatch('v3/saveScoreAndProgress', payload);
          } catch (e) {
            this.onLoadData();
          }

          // this.$store.commit('v3/v3IsLearnOff');
        }
      }

      //posttest
      if (isPostTest) {
        if (!payload[0].codeItem) {
          //call on Load
          this.onLoadData();
        } else {
          //dispatch
          this.$store.dispatch('v3/saveScoreAndProgress', payload);
          this.$store.commit('v3/v3IsLearnOff');
        }
      } else {
        //chcekisLearn if false onLoad Data and progress
        //if true go saveprogressAndScore
        if (!isLearn) {
          //isLearn is false
          //call on load normally
          this.onLoadData();
        } else {
          this.$store.dispatch('v3/saveScoreAndProgress', payload);
          // this.$store.commit('v3/v3IsLearnOff');
        }
      }
    },
    nextRoute: function (path) {
      this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage
      if (path != '' && typeof path != 'object') {
        let str = path.split('-');

        const nextPath = `/v3/${str[0]}/${str[1]}`;
        this.$store.commit('v3/stampMainCodeItem', path);
        this.$store.commit('v3/v3IsLearnOn');
        this.$store.commit('v3/v3IsUpdateProgressOn'); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
        this.$router.push(nextPath); // เปลี่ยนหน้า
      } else if (typeof path == 'object') {
        if (path.lock) {
          this.adminLockTestModal = true;
        } else {
          let str = path.path.split('-');

          const nextPath = `/v3/${str[0]}/${str[1]}`;
          // this.$router.push(body);
          this.$store.commit('v3/stampMainCodeItem', path.path); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
          this.$store.commit('v3/v3IsLearnOn');
          this.$store.commit('v3/v3IsUpdateProgressOn'); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
          this.$router.push(nextPath); // เปลี่ยนหน้า
        }
      }
    },
    nextRouteList: function (path) {
      if (path != null) {
        if (parseInt(path) == 0) {
          //vocab list
          console.log(path);

          this.$router.push('/v3/LS04/1');
        } else if (parseInt(path) == 1) {
          //vdo list
          console.log(path);

          this.$router.push('/v3/CLP01/1');
        } else if (typeof path == 'object') {
          if (path.lock) {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          } else if (path.lock == false) {
            //post test
            console.log(path);
            //stamp codeItem
            this.$store.commit('v3/stampMainCodeItem', path.codeItem);
            //posttest on
            this.$store.commit('v3/v3IsPostTestOn');
            //

            this.$router.push('/v3/CMD01/90');
          } else {
            this.adminLockPostTestModal = true;
            this.detail_posttest = path.detail;
          }
        }
      }
    },
    v3ManageData: function (progress) {
      // this.content = this.$store.state.v3.templates.templates[0].content.item;
      // this.menuCHN2 = this.$store.state.v3.templates.menuCHN2;
      //check if have progress
      if (
        !progress ||
        !Array.isArray(progress.progress) ||
        !Array.isArray(progress.subProgress)
      )
        return;

      // console.log('Data After Get Progress', progress);
      let preTest = null;
      const allChapters = [];
      const subProgress = [];

      // console.log('this.content', this.content);
      // console.log('this.menuCHN2', this.menuCHN2);
      // console.log('watch', progress);

      const mainProgress = progress.progress;
      this.v3SubProgress = progress.subProgress;

      // console.log('mainProgress', mainProgress);
      // console.log('v3SubProgress', progress.subProgress);

      // then use this mix with progress
      const typeLesson = ['Start', 'Vocabulary', 'Assignment', 'Test'];
      for (let i = 0; i < this.menuCHN2.length; i++) {
        const chapter = this.menuCHN2[i];
        let mainChapter = null;
        let topics = [];
        let mainProgressNum = 0;
        let nextLock = false;

        if (mainProgress.length > 0) {
          // ใช้การ loop ข้อมูลแบบ paralle เนื่องจากข้อมูลมี structure เหมือนกันเเละจำนวนเท่ากัน
          mainChapter = mainProgress[i];
        }

        if (i >= 1 && i <= this.menuCHN2.length - 4) {
          // ไว้สำหรับแสดงตรง popup ของ result เพื่อดูโปรเกสเเละคะแนนของบทย่อย
          for (let l = 0; l < chapter.templateItem.length; l++) {
            const subChapter = chapter.templateItem[l];

            const sub = progress.subProgress.find(
              (p) => p.codeItem === subChapter
            ) || {
              progress: 0,
              score: 0,
            };

            const state = {
              type: typeLesson[l],
              order: l,
              progress: sub.progress,
              score: sub.score,
              topicCode: subChapter,
            };
            topics.push(state);
          } //loop3

          let refine = {
            chapter: chapter.codeItem,
            topics: topics,
          };

          subProgress.push(refine);
        }

        //log

        // เช็ค main progress ว่ามีข้อมูลของ progress ไหม
        if (mainChapter) {
          if (mainChapter.progress) {
            mainProgressNum = mainChapter.progress;
          }
        }

        let schema = {
          // สำหรับใช้แสดงข้มูลของโปรเกสหลักพร้อมกับเงื่อนไขเช็ค lock บท
          code: chapter.codeItem,
          progress: mainProgressNum,
          lock: false,
          number: i,
          type: chapter.type,
        };

        // for (let j = 0; j < this.v3Progress.length; j++) {
        //   // main progress
        //   const progItem = this.v3Progress[j];
        //   console.log(progItem);

        //   if (progItem.code) {
        //     if (chapter.codeItem == progItem.code) {
        //       schema.progress = progItem.progress;
        //     }
        //   }
        // } // loop 2
        // console.log(schema.progress);

        // if (schema.progress < 80 && i >= 2) {
        if (schema.progress < 70) {
          // i > 1 is chapter 2 until others chapter end
          if (mainProgress[i - 1]?.progress < 70) {
            nextLock = true;
          }
        }
        schema.lock = nextLock;

        allChapters.push(schema); // set default first
      }

      this.v3Progress = allChapters;
      this.subProgress = subProgress;
      this.v3FetchProgress = progress;

      // console.log(allChapters, 'allChapters');

      this.allContent = {
        menuLock: this.v3Progress,
        checkPoints: progress.subProgress,
      };

      // this.allContent.menuLock = this.v3Progress;
      // this.allContent.checkPoints = progress.subProgress;
      // console.log(this.v3FetchProgress, 'in managev3');

      // console.log('this.v3Progress', this.v3Progress);
      // console.log();

      /////////////////////////////////////
      ////// PRETEST CHECK
      //check mainProgress type for pretest

      for (let j = 0; j < mainProgress.length; j++) {
        const progress = mainProgress[j];

        if (progress.type == 'pretest') {
          if (preTest == null) {
            preTest = progress;
          }
        }
      }

      if (preTest) {
        if (preTest.progress < 50) {
          // ทำตัว re-direct ไปที่หน้า CTT01-11

          const pretestStart = 'VAT01-11';
          const pathFormat = pretestStart.split('-');

          this.$store.commit('v3/v3PretestOn');
          this.$store.commit('v3/stampMainCodeItem', pretestStart);
          this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

          this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
        } else {
          console.log('pre test off');

          this.$store.commit('v3/v3PretestOff');
        }
      }

      // this.allContent = data;
      this.$store.commit('necessary/setMenuLockChinese2', this.v3Progress);
    },
    tryCallV3ManageData() {
      if (this.templateReady && this.progressReady && this.v3FetchProgress) {
        console.log('everythings ready');

        this.v3ManageData(this.v3FetchProgress);
      }
    },
    checkIsPostTest() {
      const isPostTest = this.$store.state.v3.isPostTest;

      //save post
      const payload = [
        {
          codeItem: this.$store.state.v3.mainCodeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: null,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: null,
          type: null,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      if (isPostTest) {
        //saveprogress
        this.$store.dispatch('v3/saveScoreAndProgress', payload);
      } else {
        //call on load normally
        this.onLoadData();
      }
    },
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getLessonAndProgress: 'template/getLessonAndProgress',

      //v3
      getTemplatev3: 'v3/getTemplates',
      getCourseProgress: 'v3/getCourseProgress',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
    }),
    // isSwiperDataReady() {
    //   //check data FOR SWIPER
    //   return (
    //     Array.isArray(this.content) &&
    //     this.content.length > 0 &&
    //     this.allContent &&
    //     Array.isArray(this.allContent.menuLock) &&
    //     this.allContent.menuLock.length > 0
    //   );
    // },
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      console.log('getTemplate have data');

      const template = val.templates[0];
      this.content = template.content.item;

      this.menuCHN2 = val.menuCHN2;
      this.templateReady = true;

      this.$store.dispatch('v3/fetchCourseProgress', {
        codeItem: this.currentRoute,
        courseId: this.$store.state.necessary.learningCourse,
        //courseId: this.$store.getters['necessary/getLerningCourse']._id
      });

      //call progress
      // this.onLoadProgress();
      // //for get manage data
      // this.tryCallV3ManageData();
    },

    storeLanguage: function (val) {
      this.lang = val;
    },

    getCourseProgress: function (val) {
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx', val);

      // if (!val) return;
      // console.log('getCourse run and have data');

      // this.v3FetchProgress = val;
      // this.progressReady = true;
      // this.v3ManageData(val);

      this.v3FetchProgress = val;
      this.progressReady = true;
      this.v3ManageData(val);
      //loading false after progress done
      this.loading = false;
    },
    saveScoreAndProgress: async function (value) {
      console.log('Life cycle...Watch', value);

      //
      //onLoad
      this.onLoadData();
      this.$store.commit('v3/v3IsUpdateProgressOff');
      //   if (value.length == 0) {
      //     return console.log('No data is call');
      //   }

      //   const isPostTest = this.$store.state.v3.isPostTest;

      //   if (isPostTest) {
      //     //commit isPostTest off
      //     this.$store.commit('v3/v3IsPostTestOff');
      //   }

      //   const isLearn = this.$store.state.v3.isLearn;
      //   const isUpdateProgress = this.$store.state.v3.isUpdateProgress;

      //   const payload = [
      //     {
      //       codeItem: this.$store.state.v3.mainCodeItem,
      //       courseId: this.$store.state.necessary.learningCourse,
      //       template: null,
      //       section: this.$store.state.v3.v3EnrollData.data.section,
      //       content: null,
      //       type: null,
      //       answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
      //       progress: 100,
      //       score: 0,
      //     },
      //   ];
      //   // console.log(isLearn, 'isLearn run');

      //   //////for store
      //   if (!isLearn) {
      //     // console.log('islearn false');

      //     //onLoad Data
      //     this.onLoadData();
      //   } else {
      //     // console.log('isLearn true save score and isUpdateProgressOn');

      //     this.$store.dispatch('v3/saveScoreAndProgress', payload);
      //     this.$store.commit('v3/v3IsUpdateProgressOn'); //set is update progress on
      //     this.$store.commit('v3/v3IsLearnOff');
      //     this.v3isLearned = true;
      //   }

      //   // console.log('-------------------');

      //   /////for isupdate progress
      //   if (isUpdateProgress) {
      //     // console.log('isUpdateProgress triggered');

      //     //save again
      //     //and onload
      //     //if learn true
      //     if (this.v3isLearned) {
      //       // console.log('v3islearned true triggered');

      //       //payload for lesson
      //       payload[0].codeItem = value[0].mainCodeItem;
      //       // console.log(payload, 'payload codelesson');

      //       //payload save data
      //       this.$store.dispatch('v3/saveScoreAndProgress', payload);
      //       //off is updataprogress
      //       this.$store.commit('v3/v3IsUpdateProgressOff');
      //       //off islearn
      //       this.$store.commit('v3/v3IsLearnOff');
      //       this.v3isLearned = false;
      //       // console.log(
      //       //   'saveScore Complete and islearn/isUpdateProgress/v3IsLearn false'
      //       // );
      //     }
      //   } else {
      //     console.log('isUpdated Progress false onLoad Normally');

      //     //onLoad
      //     this.onLoadData();
      //   }
    },
  },
  beforeDestroy() {
    // this.$store.commit('v3/clearCourseProgress'); //เคลีย progress เก่าออก // ปล.ทำให้ watch เรียก 2 รอบต้องระวัง
  },
  created() {},
  mounted() {
    // //take onload to checkpretest
    // // this.checkPreTestAndLoad();

    if (
      this.$store.state.v3.lessonCode &&
      this.$store.state.v3.isUpdateProgress
    ) {
      const payload = [
        {
          codeItem: this.$store.state.v3.lessonCode,
          courseId: this.$store.state.necessary.learningCourse,
          template: null,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: null,
          type: null,
          answering: [], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: 0,
        },
      ];
      this.$store.dispatch('v3/saveChapterProgress', payload);
    } else {
      this.onLoadData();
    }

    // let payload = {
    //   templateCode: this.currentRoute,
    //   code: this.code,
    //   section: this.section,
    // };
    // console.log(payload.section);
    // this.$store.dispatch("template/fetchLessonAndProgress", payload);
    // this.subProgress = data.menuSubProgress
    // this.allContent = data;
    // this.v3ManageData();
    // this.$store.commit("necessary/setMenuLockChinese2", data.menuLock);
    // this.onLoadData();
    // this.onLoadProgress();
    // console.log(this.content, 'content');
    // console.log(this.allContent.checkPoints, 'checkpoint');
  },
};
</script>

<style>
@import 'https://unpkg.com/fullpage.js/dist/fullpage.min.css';

* {
  user-select: none;
}

.modal-title {
  color: white;
}

.modal-light .modal-header {
  background-color: #808588;
}

.btn-light,
.btn-light:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary,
.btn-secondary:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}

.body-slide {
  display: flex;
  margin-top: 14%;
  width: 100%;
  justify-content: center;
}

#fp-nav ul,
.fp-slidesNav ul {
  margin: 0;
  padding: 0;
  display: flex;
  height: 80vh;
  flex-direction: column;
  justify-content: space-around;
  background-color: #89abe6;
  border-radius: 20px;
  width: 6px;
  align-items: center;
}

#fp-nav:hover ul li a span,
.fp-slidesNav ul li a span {
  margin: -2px 0 0 -2px;
  width: 15px;
  height: 15px;
}

#fp-nav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li a.active span,
.fp-slidesNav ul li:hover a.active span {
  height: 20px;
  width: 20px;
  margin: -6px 0 0 -6px;
  border-radius: 100%;
  position: absolute;
  left: 30%;
  background-color: #1d5bd7;
}

#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  height: 15px;
  width: 15px;
  border: 0;
  background: #89abe6;
  left: 10%;
  /* top: 50%; */
  margin: -2px 0 0 -2px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

@media only screen and (min-width: 300px) and (max-width: 1024px) {
  #fp-nav ul,
  .fp-slidesNav ul {
    margin: 0;
    padding: 0;
    display: flex;
    height: 5vh;
    flex-direction: column;
    border-radius: 20px;
    width: 0;
  }

  #fp-nav ul li a.active span,
  #fp-nav ul li:hover a.active span,
  .fp-slidesNav ul li a.active span,
  .fp-slidesNav ul li:hover a.active span {
    height: 12px;
    width: 12px;
    margin: -6px 0 0 -6px;
    border-radius: 100%;
    position: absolute;
    left: 10%;
    background-color: #1d5bd7;
  }

  #fp-nav ul li a span,
  .fp-slidesNav ul li a span {
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    height: 10px;
    width: 10px;
    border: 0;
    background: #89abe6;
    left: -10%;
    top: 50%;
    margin: -2px 0 0 -2px;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -o-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  .card {
    border: 0;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
  }
}

@media only screen and (min-width: 1600px) {
  #fp-nav.fp-left {
    left: 17px;
    margin-left: 3%;
  }
}
</style>
